import { isWeb } from './utils.js';

type Props = React.PropsWithChildren<{ wrapper: (c: React.ReactNode) => React.ReactNode }>;

export function WebOnlyWrapper({ wrapper, children }: Props) {
  return isWeb() ? wrapper(children) : children;
}
